<template>
  <div>
    <div class="row">
        <div class="col-sm-12">
          <div class="page-title-box">
            <div class="float-right">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="javascript:void(0);">BPD BALI</a></li>
                <li class="breadcrumb-item active">Laporan Summary</li>
              </ol>
            </div>
            <h4 class="page-title">Laporan Summary</h4>
          </div>
        </div>
      </div>

    <div class="card card-loader d-flex" v-if="loading">
          <div class="justify-content-center">
            <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <p class="mt-2">Loading</p>
          </div>
      </div>

      <div class="card" v-else>
          <div class="card-body">
            <div class="wrapper-table-default">
                <div class="row mb-3">
                    <div class="col-12 col-md-4">
                        <select name="" id="" class="form-control" v-model="filter.company">
                            <option :value="null">Semua Instansi</option>
                            <option :value="item.id" v-for="item in allCompany" :key="item.id">{{item.name}}</option>
                        </select>
                    </div>
                    <div class="col-12 col-md-4">
                        <date-picker required style="width: 100%" v-model="filter.date" :placeholder="'Dari - Sampai'" format="DD/MM/YYYY" range></date-picker>
                    </div>
                    <div class="col-12 col-md-4">
                        <button class="btn btn-primary" @click="loadData">Filter</button>
                        <button class="btn btn-warning ml-3" @click="exportData">Export Data</button>
                    </div>
                </div>
                <div class="table-responsive" v-if="dataSummary">
                    <div class="row">
                        <div class="col-12 col-md-3">
                            <div class="card card-eco" style="border: 1px solid #ddd;">
                                <div class="card-body" style="padding: 15px">
                                    <h4 class="title-text mt-0 mb-0">Jumlah Penetapan</h4>
                                    <div class="d-flex justify-content-between">
                                        <h3 style="font-size: 18px" class="font-weight-bold mb-0">{{dataSummary.details.jumlah_penetapan}}</h3>
                                    </div>                                     
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-3">
                            <div class="card card-eco" style="border: 1px solid #ddd;">
                                <div class="card-body" style="padding: 15px">
                                    <h4 class="title-text mt-0 mb-0">Jumlah Transaksi</h4>
                                    <div class="d-flex justify-content-between">
                                        <h3 style="font-size: 18px" class="font-weight-bold mb-0">{{dataSummary.details.jumlah_transaksi}}</h3>
                                    </div>                                     
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-3">
                            <div class="card card-eco" style="border: 1px solid #ddd;">
                                <div class="card-body" style="padding: 15px">
                                    <h4 class="title-text mt-0 mb-0">Total Penetapan</h4>
                                    <div class="d-flex justify-content-between">
                                        <h3 style="font-size: 18px" class="font-weight-bold mb-0">{{currency(dataSummary.details.total_penetapan)}}</h3>
                                    </div>                                     
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-3">
                            <div class="card card-eco" style="border: 1px solid #ddd;">
                                <div class="card-body" style="padding: 15px">
                                    <h4 class="title-text mt-0 mb-0">Total Transaksi</h4>
                                    <div class="d-flex justify-content-between">
                                        <h3 style="font-size: 18px" class="font-weight-bold mb-0">{{currency(dataSummary.details.total_transaksi)}}</h3>
                                    </div>                                     
                                </div>
                            </div>
                        </div>
                    </div>
                    <table id="table-default" class="table table-hover with-action-last" cellspacing="0" width="100%">
                        <thead>
                            <tr>
                                <th class="text-center">Kode</th>
                                <!-- <th class="text-center">Instansi</th> -->
                                <th class="text-center">Nama</th>
                                <th class="text-right">Penetapan</th>
                                <th class="text-right">Realisasi</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="dataSummary.length <= 0">
                                <td colspan="4" class="text-center">Data tidak ditemukan</td>
                            </tr>
                            <tr v-for="(item) in dataSummary.summaries" :key="item.id" v-else>
                                <td>{{ item.code }}</td>
                                <!-- <td class="text-center">{{ item.company.name }}</td> -->
                                <td class="text-center">{{ item.name ? item.name : 'Lainnya' }}</td>
                                <td class="text-right">{{ currency(item.penetapan) }}</td>
                                <td class="text-right">{{ currency(item.realisasi) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-else>
                    <h2 class="text-center mt-5" style="font-size: 16px; background-color: #989898; padding: 7px; border-radius: 5px; color: #fff">Harap Memilih Instansi dan Periode Terlebih Dahulu</h2>
                </div>
            </div>
          </div>
      </div>
      
      <div class="modal fade" id="modalDetail" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title mt-0" id="mySmallModalLabel">
                        <span v-if="loadingDetail">Loading ...</span>
                        <span v-else>#{{dataDetail.invoice_code}}</span>
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                </div>
                <div class="modal-body">
                    <div class="card card-loader d-flex" v-if="loadingDetail" style="height: 50vh; background-color: transparent">
                        <div class="justify-content-center">
                            <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                            <p class="mt-2">Loading</p>
                        </div>
                    </div>

                    <div v-else>
                        <div class="row align-items-center" style="margin-bottom: 20px">
                            <div class="col-12 col-md-9">
                                <div class="d-flex align-items-center">
                                    <!-- <img :src="$store.state.userData.company_logo" style="height: 50px" class="mr-5"> -->
                                    <table>
                                        <tr>
                                            <td><b>Invoice Code</b></td>
                                            <td>: #{{ dataDetail.invoice_code }}</td>
                                        </tr>
                                        <tr>
                                            <td><b>Tanggal</b></td>
                                            <td>: {{ dataDetail.invoice_date }}</td>
                                        </tr>
                                        <tr>
                                            <td><b>Metode Pembayaran</b></td>
                                            <td>: {{ dataDetail.payment_method ? paymentMethodName(dataDetail.payment_method) : '-' }}</td>
                                        </tr>
                                        <tr v-if="dataDetail.is_penalty">
                                            <td><b>Periode Denda</b></td>
                                            <td>: {{ dataDetail.penalty_period_value }} {{ convertPeriod(dataDetail.penalty_period) }}</td>
                                        </tr>
                                        <tr v-if="dataDetail.is_penalty">
                                            <td><b>Jumlah Denda</b></td>
                                            <td>: {{ dataDetail.penalty_nominal_type == 'PERCENTAGE' ? dataDetail.penalty_nominal_value : currency(dataDetail.penalty_nominal_value) }} {{ dataDetail.penalty_nominal_type == 'PERCENTAGE' ? '%' : '' }}</td>
                                        </tr>
                                        <tr v-if="dataDetail.va_no">
                                            <td><b>No VA</b></td>
                                            <td>: {{ dataDetail.va_no }}</td>
                                        </tr>
                                        <tr v-if="dataDetail.status">
                                            <td><b>Status</b></td>
                                            <!-- <td>: {{ dataDetail.status }}</td> -->
                                            <td v-if="dataDetail.status == 'SUCCESS'"><span class="badge badge-success">SUKSES</span></td>
                                            <td v-else-if="dataDetail.status == 'PENDING'"><span class="badge badge-warning">PENDING</span></td>
                                            <td v-else-if="dataDetail.status == 'WAITING_PROCESS'"><span class="badge badge-primary">MENUNGGU PERSETUJUAN</span></td>
                                            <td v-else-if="dataDetail.status == 'WAITING_CONFIRMATION'"><span class="badge badge-primary">DRAFT</span></td>
                                            <td v-else><span class="badge badge-danger">EXPIRED</span></td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <div class="col-12 col-md-3">
                                <div class="text-center">
                                    <button type="button" class="btn btn-primary" @click.prevent="refreshTransaction">
                                        <i class="fas fa-sync-alt"></i>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-12">
                                <div class="table-responsive">
                                    <table class="table table-bordered mb-0">
                                        <thead>
                                            <tr>
                                                <th>Kategori Retribusi</th>
                                                <th class="text-right">Harga</th>
                                                <th class="text-right">Jumlah</th>
                                                <th class="text-right">Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item in dataDetail.objectRetribution" :key="item.id">
                                                <th>{{item.service_name}}</th>
                                                <td class="text-right">{{currency(item.price)}}</td>
                                                <td class="text-right">{{item.qty}}</td>
                                                <td class="text-right">{{currency(item.total)}}</td>
                                            </tr>
                                            <tr>
                                                <th colspan="2" class="border-0"></th>
                                                <td class="border-0 font-14"><b>Total</b></td>
                                                <td class="bg-dark text-white border-0 font-14 text-right"><b>{{currency(dataDetail.total)}}</b></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <hr>

                    <div class="row d-flex justify-content-center">
                        <a href="#" class="btn btn-primary" data-dismiss="modal">Tutup</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import moment from "moment"
import fileDownload from 'js-file-download'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

export default {
    data() {
        return {
            loading: true,
            loadingDetail: false,
            loadingExport: false,

            filter: {
                company: null,
                date: [null,null],
                status: null,
            },

            allCompany: [],
            dataDetail : '',
            dataSummary: null,
        }
    },
    components: {
        DatePicker
    },
    methods: {
        convertPeriod(period) {
            if(period == 'DAILY'){
                return 'Harian'
            }else if(period == 'WEEKLY'){
                return 'Minggu'
            }else if(period == 'MONTHLY'){
                return 'Bulan'
            }else{
                return 'Tahun'
            }
        },
        loadDetail(id) {
            this.loadingDetail = true

            $('#modalDetail').modal('show')
            
            this.$http.get(`${this.API_URL}transaction/${id}`, {
                headers: { 'Authorization': `Bearer ${this.$cookies.get("token_group")}` }
            })
            .then(response => {
                const result = response.data;
                if(result.success) {
                    this.dataDetail = result.data
                    setTimeout(() => {
                        this.loadingDetail = false;
                    }, 100);
                }else {
                    this.sAlert('error', result.message)
                    this.loadingDetail = false;
                }
            })
            .catch(error => {
                this.loadingDetail = false;
                this.sAlert('error', "Error, Terjadi Kesalahan!")
            });
        },
        async loadData() {
            if(this.filter.date[0] == null || this.filter.date[1] == null) {
                this.sAlert('error', 'Mohon memilih periode terlebih dahulu')
                return
            } 

            this.loading = true;
            try {
                let storedData = {
                    company_id: this.filter.company,
                    start_date: this.filter.date[0] ? moment(this.filter.date[0]).format('YYYY-MM-DD') : null,
                    end_date: this.filter.date[1] ? moment(this.filter.date[1]).format('YYYY-MM-DD') : null
                }

                const summary = await this.$http.get(`${this.API_URL}summary-report`, 
                    {
                        params: storedData,
                        headers: { 'Authorization': `Bearer ${this.$cookies.get("token_group")}` 
                    }
                })
                this.dataSummary = summary.data.data

                setTimeout(() => {
                    this.dataTableSearch()
                }, 500);
                
                this.loading = false;
            } catch (error) {
                this.loading = false;
                this.sAlert('error', "Error, Terjadi Kesalahan!")
            }
        },
        async exportData() {
            this.loadingExport = true;
            try {
                let storedData = {
                    company_id: this.filter.company,
                    start_date: this.filter.date[0] ? moment(this.filter.date[0]).format('YYYY-MM-DD') : null,
                    end_date: this.filter.date[1] ? moment(this.filter.date[1]).format('YYYY-MM-DD') : null,
                    export: 1
                }

                const response = await this.$http.get(`${this.API_URL}summary-report`, {
                    responseType: 'blob',
                    params: storedData,
                    headers: { 
                        'Authorization': `Bearer ${this.$cookies.get("token_group")}`,
                    }
                })

                fileDownload(response.data, 
                `Laporan Summary${this.filter.company ? '-' + this.allCompany.find(item => item.id == this.filter.company).name : ''}${this.filter.date[0] ? '-' + this.filter.date[0] : ''}${this.filter.date[1] ? '-' + this.filter.date[1] : ''}.pdf`);
                this.loadingExport = false

            } catch (error) {
                console.log(error);
                this.loadingExport = false;
                this.sAlert('error', "Error, Terjadi Kesalahan!")
            }
        },
        convertDate(date){
            return moment(date).format('DD MMMM YYYY')
        }
    },
    async mounted() {
        this.loading = true
        if(this.allCompany <= 0){
            const company = await this.$http.get(`${this.API_URL}group/company`, 
                {
                    headers: { 'Authorization': `Bearer ${this.$cookies.get("token_group")}` 
                }
            })
            this.allCompany = company.data.data
        }
        this.loading = false
    }
}
</script>